import React from "react";

function SlaReportItem({data}){
    
    return(
        <>
            {data.map((item, index) => (
                <React.Fragment key={index}>
                    {/* 장애관리 */}
                    {index === 0 && (
                        <tr>
                            <th className={"fieldset-th-sla pt-1.5 pb-1.5"} rowSpan={3}>장애관리</th>
                            <th className={"fieldset-th-sla pt-1.5 pb-1.5"}>장애 건수</th>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.weight}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>월간</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.goal}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.min}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.checkResult}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.checkValue}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.customerCheckResult}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.customerCheckValue}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.etc}</td>
                        </tr>
                    )}
                    {index === 1 && (
                        <tr>
                            <th className={"fieldset-th-sla pt-1.5 pb-1.5"}>장애 복구율</th>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.weight}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>월간</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.goal}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.min}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.checkResult}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.checkValue}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.customerCheckResult}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.customerCheckValue}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.etc}</td>
                        </tr>
                    )}


                    {index === 2 && (
                        <tr>
                            <th className={"fieldset-th-sla pt-1.5 pb-1.5"}>동일 장애발생건수</th>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.weight}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>월간</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.goal}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.min}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.checkResult}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.checkValue}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.customerCheckResult}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.customerCheckValue}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.etc}</td>
                        </tr>
                    )}

                    {/* 관리서비스 */}
                    {index === 3 && (
                        <tr>
                            <th className={"fieldset-th-sla pt-1.5 pb-1.5"} rowSpan={5}>관리서비스</th>
                            <th className={"fieldset-th-sla pt-1.5 pb-1.5"}>보고</th>
                            <th className={"fieldset-th-sla pt-1.5 pb-1.5"}>적기보고 실시율</th>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.weight}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>월간</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.goal}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.min}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.checkResult}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.checkValue}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.customerCheckResult}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.customerCheckValue}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.etc}</td>
                        </tr>
                    )}
                    {index === 4 && (
                        <tr>
                            <th className={"fieldset-th-sla pt-1.5 pb-1.5"}>관리</th>
                            <th className={"fieldset-th-sla pt-1.5 pb-1.5"}>각종 산출물 납기 일정 준수율</th>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.weight}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>월간</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.goal}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.min}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.checkResult}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.checkValue}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.customerCheckResult}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.customerCheckValue}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.etc}</td>
                        </tr>
                    )}
                    {index === 5 && (
                        <tr>
                            <th className={"fieldset-th-sla pt-1.5 pb-1.5"} colSpan={2}>서비스 요청 적기 처리율</th>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.weight}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>월간</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.goal}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.min}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.checkResult}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.checkValue}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.customerCheckResult}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.customerCheckValue}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.etc}</td>
                        </tr>
                    )}
                    {index === 6 && (
                        <tr>
                            <th className={"fieldset-th-sla pt-1.5 pb-1.5"} colSpan={2}>작업 적기 처리율</th>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.weight}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>월간</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.goal}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.min}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.checkResult}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.checkValue}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.customerCheckResult}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.customerCheckValue}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.etc}</td>
                        </tr>
                    )}
                    {index === 7 && (
                        <tr>
                            <th className={"fieldset-th-sla pt-1.5 pb-1.5"} colSpan={2}>점검 적기 처리율</th>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.weight}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>월간</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.goal}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.min}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.checkResult}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.checkValue}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.customerCheckResult}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.customerCheckValue}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.etc}</td>
                        </tr>
                    )}

                    {/* 성능개선 제안 */}
                    {index === 8 && (
                        <tr>
                            <th className={"fieldset-th-sla pt-1.5 pb-1.5"} colSpan={3}>성능개선 제안</th>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.weight}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>월간</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.goal}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.min}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.checkResult}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.checkValue}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.customerCheckResult}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.customerCheckValue}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.etc}</td>
                        </tr>
                    )}

                    {/* 내부자료 유출 */}
                    {index === 9 && (
                        <tr>
                            <th className={"fieldset-th-sla pt-1.5 pb-1.5"} colSpan={3}>내부자료 유출 및 중요 데이터 손실</th>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.weight}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>월간</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.goal}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.min}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.checkResult}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.checkValue}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.customerCheckResult}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.customerCheckValue}%</td>
                            <td className={"fieldset-td-sla pt-1.5 pb-1.5"}>{item.etc}</td>
                        </tr>
                    )}
                </React.Fragment>
            ))}
        </>
    )
}

export {SlaReportItem}